/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Nav_OnlineInputs */

const en_fc_nav_online = /** @type {(inputs: Fc_Nav_OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use Online`)
};

/**
* | output |
* | --- |
* | "Use Online" |
*
* @param {Fc_Nav_OnlineInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_nav_online = /** @type {((inputs?: Fc_Nav_OnlineInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Nav_OnlineInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_nav_online(inputs)
});
export { fc_nav_online as "fc.nav.online" }